import {
  PaginationArrowLeftIcon,
  PaginationArrowRightIcon,
  PaginationDoubleArrowLeftIcon,
  PaginationDoubleArrowRightIcon,
} from "..";

interface PaginationProps {
  maxPagesToRender: number;
  pageIndex: number;
  totalPages: number[];
  gotoPage: (page: number) => void;
  previousPage: () => void;
  nextPage: () => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
}

export const Pagination = (props: PaginationProps) => {
  const { canNextPage, canPreviousPage, pageIndex, gotoPage, maxPagesToRender, nextPage, previousPage, totalPages } =
    props;

  const maxPagesToShowInNavigation = totalPages.length >= maxPagesToRender ? maxPagesToRender : totalPages.length;

  const firstPageToShow =
    pageIndex + maxPagesToShowInNavigation > totalPages.length
      ? totalPages.length - maxPagesToShowInNavigation
      : pageIndex;

  const navigationPages =
    totalPages.length > 0 ? totalPages.slice(firstPageToShow, firstPageToShow + maxPagesToShowInNavigation) : [0];

  return (
    <>
      <nav className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} type="button">
          <PaginationDoubleArrowLeftIcon dataTestId="pagination-double-arrow-left-icon" />
        </button>
        <button onClick={() => previousPage()} disabled={!canPreviousPage} type="button">
          <PaginationArrowLeftIcon dataTestId="pagination-arrow-left-icon" />
        </button>
        {navigationPages.map((pageNumber) => (
          <button
            key={`page-number-${pageNumber}`}
            onClick={() => gotoPage(pageNumber)}
            className={pageNumber === pageIndex ? "active" : ""}
            type="button"
            data-testid="pagination-page-button"
          >
            {pageNumber + 1}
          </button>
        ))}
        <button onClick={() => nextPage()} disabled={!canNextPage} type="button">
          <PaginationArrowRightIcon dataTestId="pagination-arrow-right-icon" />
        </button>
        <button onClick={() => gotoPage(totalPages.length - 1)} disabled={!canNextPage} type="button">
          <PaginationDoubleArrowRightIcon dataTestId="pagination-double-arrow-right-icon" />
        </button>
      </nav>
    </>
  );
};
